"use client";
import { useEffect } from "react";
import { useState } from "react";
import { Product } from "~/use-cases/contracts/Product";
import { ProductVariant as SelectedVariant } from "~/use-cases/contracts/ProductVariant";

type LipscoreReviewProps = {
  product: Product;
  selectedVariant: SelectedVariant;
};

const LipScoreReview = ({ product, selectedVariant }: LipscoreReviewProps) => {
  const [productUrl, setProductUrl] = useState<string>("");

  useEffect(() => {
    setProductUrl(window.location.href);
  });
  return (
    <div className="lipscore-reviews mb-10">
      <h2 className="font-semibold mt-4 text-2xl lg:text-3xl">Reviews</h2>
      <div
        id="lipscore-review-list"
        data-ls-product-name={product?.name}
        data-ls-brand={product?.brand}
        data-ls-product-id={selectedVariant?.sku}
        data-ls-product-url={productUrl}
        data-ls-variant-id={selectedVariant?.id}
        data-ls-variant-name={selectedVariant?.name}
        data-ls-sku={selectedVariant?.sku}
        data-ls-description={product?.description}
        data-ls-image-url={selectedVariant?.images[0]?.url}
        data-ls-price={selectedVariant.priceVariants?.default.priceFor.price}
        data-ls-price-currency={
          selectedVariant?.priceVariants?.default.currency.code
        }
        data-ls-availability={
          selectedVariant?.outofstock.content?.value === true
            ? "out_of_stock"
            : "in_stock"
        }
        data-ls-category={product.topics?.map((topic) => topic.name).join(",")}
        data-ls-mpn={product.mpn ? product?.mpn : product?.ean}
        data-ls-gtin={product?.ean}
        data-ls-page-size="5"
      ></div>
    </div>
  );
};

export default LipScoreReview;
